import { matchValues } from '@shared/core/types/common';

const countries: OLO.Types.COUNTRIES[] = ['AU', 'NZ', 'PL', 'US'];

export const countriesType = matchValues(...countries);
